import { Text } from '@/components/text';
import { Colors } from '@/constants/theme';
import MaterialIcons from '@expo/vector-icons/MaterialIcons';
import { Pressable, StyleSheet, View, ViewStyle } from 'react-native';

export type ChipProps = {
    label: string;
    onRemove?: () => void;
    disabled?: boolean;
    style?: ViewStyle;
};

export function Chip({ label, onRemove, disabled, style }: ChipProps) {
    return (
        <View style={[styles.chip, style]} >

            <Text style={styles.chipText} >{label}</Text>
            {onRemove && !disabled && (
                <Pressable
                    onPress={e => {
                        e.stopPropagation();
                        onRemove();
                    }}
                    hitSlop={8}>
                    <MaterialIcons name="close" size={14} color={Colors.light.icon} />
                </Pressable>
            )}
        </View>
    );
}

const styles = StyleSheet.create({
    chip: {
        flexDirection: 'row',
        alignItems: 'center',
        backgroundColor: 'rgba(11, 95, 255, 0.05)',
        borderRadius: 6,
        borderColor: Colors.light.primary,
        borderWidth: 1,
        paddingHorizontal: 6,
        paddingVertical: 1,
        gap: 4,
    },
    chipText: {
        fontSize: 12,
        fontWeight: 'bold',
        color: Colors.light.primary,
    },
});
